import i18next from 'i18next';

import { METRIC_TYPE } from '../../common/utils';

export const getMetricOptions = (enableTicketsNumber) => {
  const defaultOptions = [
    {
      id: 'turnoverExcludingTaxes',
      value: i18next.t('GENERAL.TURNOVER_EX_TAX'),
      type: METRIC_TYPE.CURRENCY,
    },
    {
      id: 'realFoodConsumption',
      value: i18next.t('ANALYSIS.PERFORMANCE.REAL_FOOD_CONSUMPTION_SHORT'),
      type: METRIC_TYPE.CURRENCY,
      isNegative: true,
    },
    {
      id: 'realFoodConsumptionRatio',
      value: i18next.t('ANALYSIS.PERFORMANCE.REAL_FOOD_CONSUMPTION_RATIO'),
      type: METRIC_TYPE.PERCENTAGE,
      isNegative: true,
    },
  ];

  if (!enableTicketsNumber) {
    return defaultOptions;
  }
  return defaultOptions.concat([
    {
      id: 'tickets',
      value: i18next.t('ANALYSIS.PERFORMANCE.TICKETS'),
      type: METRIC_TYPE.INTEGER,
    },
    {
      id: 'averageTicket',
      value: i18next.t('ANALYSIS.PERFORMANCE.AVERAGE_TICKET'),
      type: METRIC_TYPE.CURRENCY_WITH_DECIMALS,
    },
  ]);
};
